import EmptyPageContent from '@app/ccf/components/empty-page-content';

/** Empty state shown in a chart card when a spend view is selected but no spend data exists. */
export function InsightsNoSpendData() {
  return (
    <EmptyPageContent
      title="No spend data"
      description="The selected purchase data does not contain spend information"
    />
  );
}
